import { Component } from '@angular/core';
import * as Constants from '@emi/shared/constants';

@Component({
  selector: 'emi-system-error',
  templateUrl: './system-error.component.html',
  styleUrls: ['./system-error.component.scss']
})
export class SystemErrorComponent {
  public helpPageUrl = Constants.ExternalLinks.ECOM_HELP_PAGE;
}
